import AdministrationService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
import Transactions from "@/modules/ngo/transactions/store";
export default {
  namespaced: true,
  state: {
    loading: false,
  },
  modules :{
    Transactions,
  },

  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
  },

  actions: {
    async addMember({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.addGeneralAuthorityMember(
          payload
        );

        if (hasError(res.status)) {
          throw res.statusText;
        }

        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت إضافة العضو بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
    async updateMember({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.updateGeneralAuthorityMember(
          payload
        );

        if (hasError(res.status)) {
          throw res.statusText;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تعديل معلومات العضو بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
    async deleteMember({ commit }, id) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.deleteGeneralAuthorityMember(
          id
        );

        if (hasError(res.status)) {
          throw res.statusText;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم حذف العضو بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
